"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsText = exports.LabelContainer = exports.Checkbox = exports.Label = exports.Input = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../Typography"));
exports.Wrapper = styled_components_1.default.div `
  display: inline-block;
  vertical-align: middle;
  margin-right: ${props => props.marginRight}px;
`;
exports.Input = styled_components_1.default.input `
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: ${props => props.theme.constants.blockWidth.xs}px;
`;
exports.Label = styled_components_1.default.label `
  display: flex;
  align-items: flex-start;
  text-transform: unset;
  font-size: ${props => props.theme.typography.size.s2}px;
  line-height: ${props => props.theme.typography.size.s2}px;
  letter-spacing: unset;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  transition: ${props => props.theme.animations.primary};

  color: ${props => (props.disabled ? props.theme.palette.LIGHT_GRAY_100 : props.theme.palette.BW_0)};
  font-size: ${props => props.theme.typography.size.s3}px;
  line-height: ${props => props.theme.typography.lineHeight.s2}px;
  font-weight: ${props => props.theme.typography.weight.regular};
`;
exports.Checkbox = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: ${props => props.theme.spacing.s5}px;
  height: ${props => props.theme.spacing.s5}px;
  background-color: ${props => props.checked
    ? props.disabled
        ? props.theme.palette.LIGHT_GRAY_30
        : props.theme.palette.BLUE_100
    : props.theme.palette.BW_100};
  border: ${props => props.theme.constants.borderWidth.xs}px solid;
  border-color: ${props => props.disabled
    ? props.theme.palette.LIGHT_GRAY_100
    : props.checked
        ? props.theme.palette.BLUE_100
        : props.theme.palette.BLUE_GRAY_40};
  transition: border ${props => props.theme.animations.primary};
  border-radius: ${props => props.theme.spacing.s0}px;
  margin: ${props => props.theme.spacing.s0}px;

  ${props => !props.disabled &&
    `
    &:focus, &:hover {
      border-color: ${props.theme.palette.ORANGE_100};
      outline: 2px solid ${props.theme.palette.ORANGE_40};
    };
  `}
`;
exports.LabelContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  margin-left: ${props => props.theme.spacing.s2}px;
  line-height: ${props => props.theme.typography.lineHeight.m1}px;
  ${props => props.isFilter &&
    `
    font-size: ${props.theme.typography.size.s2}px;
    line-height: ${props.theme.typography.lineHeight.s6}px;
    color: ${props.theme.palette.LIGHT_BLACK};
  `}
`;
exports.ResultsText = (0, styled_components_1.default)(Typography_1.default) `
  margin-left: ${props => props.theme.spacing.s2}px;
  margin-right: ${props => props.theme.spacing.s0}px;
  color: ${props => props.theme.palette.DARK_GRAY_40};
`;
exports.default = {
    Checkbox: exports.Checkbox,
    Label: exports.Label,
    Input: exports.Input,
    LabelContainer: exports.LabelContainer
};
